import { InputLabel, InputWrapper } from '@econsult/econsult-ui/dist/components/Input/InputStyles';
import { Paragraph } from '@econsult/econsult-ui/dist/components/shared/typography';
import { FieldSet, FlexInput, Form, InputRow } from 'components/Form';
import { TextFlow } from 'components/Typography';
import styled from 'styled-components';

export const SettingsSection = styled(TextFlow)`
  padding-bottom: 1.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.colorPrimaryPrimary10};
`;

export const SettingsSectionHeading = styled(Paragraph)`
  font-size: 18px;
  color: ${({ theme }) => theme.colorNeutralBlack};
  margin: 0;
  font-weight: 700;
`;

export const SettingsSectionSubHeading = styled(SettingsSectionHeading)`
  font-size: 16px;
`;

export const SettingsFieldDescription = styled.div``;

export const SettingForm = styled(Form)``;

export const Setting = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  column-gap: 1.5rem;
  row-gap: 1.5rem;
`;

export const SettingInfo = styled.div`
  grid-column: 1 / 2;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const SettingDetail = styled.div`
  grid-column: 2;
  grid-row: 1;

  ${Form} {
    grid-column: 1 / 4;
    align-items: end;
  }

  ${InputRow} {
    flex-direction: column;
    align-items: end;
  }

  ${FieldSet} {
    width: 100%;
  }

  ${InputWrapper} {
    width: 100%;
    grid-column: 1 / 4;
  }

  ${InputLabel} {
    font-size: 14px;
    color: ${({ theme }) => theme.colorPrimaryPrimary100};
  }

  ${FlexInput} {
    min-height: 7rem;
    font-size: 14px;
    line-height: 1.4;
  }
`;

export const FlexSettingWrapper = styled.div`
  display: flex; 
  flex-direction: column;
  gap: 1rem;
`;
